import { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Typography } from "@mui/material";
import LoadingButton from "@mui/lab/LoadingButton";

import { PasswordInput } from "../../../Components/PasswordInput/PasswordInput";
import { useAuthTwoVerifyMutation } from "../../../States";
import Headers from "../../../Components/Layouts/Headers.layout";

const defaultErrorMessage: string = "رمز عبور باید حداقل 8 کارکتر باشد";

export function TwoStepVerifyForm(props: any): JSX.Element {
  const navigate = useNavigate();
  const location = useLocation();

  const [
    authTwoVerify,
    { isLoading: loadingTwoVerify, isSuccess: successTwoVerify },
  ] = useAuthTwoVerifyMutation();

  const [currentPhone, setCurrentPhone] = useState<string>("");
  const [password, setPassword] = useState<string>("");
  const [isFirstTime, setisFirstTime] = useState<boolean>(true);
  const [passwordError, setPasswordError] = useState<string | undefined>(
    undefined
  );

  // get phone from prev step
  useEffect(() => {
    const { phone, code } = location.state;
    if (!phone) {
      navigate("/auth");
    } else if (!code) {
      navigate("/auth/verify", { state: phone });
    } else {
      setCurrentPhone(phone);
    }
  }, [location.state, navigate]);

  useEffect(() => {
    if (password?.length < 8 && !isFirstTime) {
      setPasswordError(defaultErrorMessage);
    } else if (password?.length >= 8) {
      setPasswordError(undefined);
    }
  }, [password, isFirstTime]);

  // submit the otp code for loging in
  const onSubmitHandler = async () => {
    if (isFirstTime) setisFirstTime(false);

    if (password?.length >= 8) {
      try {
        await authTwoVerify({
          phone: currentPhone ? currentPhone : "",
          password: password,
        }).unwrap();
      } catch (error: any) {
        const errorMessage = error?.data?.response?.data?.password[0];
        setPasswordError(errorMessage);
      }
    }
  };

  //  on success
  useEffect(() => {
    if (successTwoVerify) {
      window.location.href = "/";
    }
  }, [successTwoVerify]);

  // handle change password input
  function onChangePassword(event: {
    target: { name: string; value: string };
  }) {
    const value = event?.target?.value.replaceAll(" ", "");

    setPassword(value);
  }

  return (
    <>
      <Headers style={{ fontSize: 16, mt: 2, mb: 1 }}>ورود دو مرحله ای</Headers>

      <Typography
        component="h4"
        sx={{ marginBottom: 3, fontSize: "14px" }}
        className="font-sans"
      >
        لطفا رمز عبور پنل مدیریت خود را وارد کنید.
      </Typography>

      <PasswordInput
        onChange={onChangePassword}
        onKeyDown={(e: any) => e.key === "Enter" && onSubmitHandler()}
        error={passwordError}
        value={password}
        label="رمز عبور"
      />

      <LoadingButton
        variant="contained"
        onClick={onSubmitHandler}
        loading={loadingTwoVerify}
        disabled={!isFirstTime && password?.length < 8}
        sx={{ marginTop: 4 }}
      >
        تایید و ادامه
      </LoadingButton>
    </>
  );
}
